import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

const TenderFormStepTwo = (props) => {
  const { t } = useTranslation();

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:tender.tenderDetails")} />
      <Row>
        <Col xs={12}>
          <Field
            name="comment"
            label={`${t("global:tender.comments")}`}
            component={BMXTextField}
            data-cy="comment"
            maxRows={4}
            multiline={true}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TenderFormStepTwo;
